import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

import { SectionHeading } from '@/components/ui';

/**
 * A section of the right panel as the UI pattern library's panel content
 * layout (P3) draws one: Web's `ui/SectionHeading`, then the content. The
 * icons are the rail's, so a section reads the same open and collapsed.
 */
export type PanelSectionProps = {
  /** Material Symbols glyph name. */
  icon: string;
  title: string;
  automationId: string;
  children: ReactNode;
};

export const PanelSection = ({ icon, title, automationId, children }: PanelSectionProps) => (
  <Stack component="section" sx={{ gap: 2 }} data-automation-id={automationId}>
    <SectionHeading icon={icon}>{title}</SectionHeading>
    {children}
  </Stack>
);
